import { compose } from 'recompose';
import withSearchableDropdownFixedBlur from '../../hoc/withSearchableDropdownFixedBlur';
import withActualDropdownFieldValue from '../../hoc/withActualDropdownFieldValue';
import FormDropdownField from '../../../FormDropdownField';
import withClassName from '../../../../utils/withClassName';
import styles from './DropdownQuestionFormField.scss';

const DropdownQuestionFormField = compose(
  withSearchableDropdownFixedBlur,
  withActualDropdownFieldValue,
  withClassName(styles.container),
)(FormDropdownField);

export default DropdownQuestionFormField;
